<template>
  <div class="banner-container">
    <div class="left">
      <div class="circle">1</div>
      <div class="circle">2</div>
      <div class="circle">3</div>
    </div>
    <div>
      <div class="content">
        <div class="title">企业认证 <img src="/static/image/marketCenter/home-certification1.svg" alt="" width="15" height="14"/></div>
        <div class="tips">填写营业执照和法定代表人信息</div>
      </div>
      <div class="content">
        <div class="title">法定代表人认证 <img src="/static/image/marketCenter/home-certification2.svg" alt="" width="12" height="13"/></div>
        <div class="tips">完成法定代表人人脸识别</div>
      </div>
      <div class="content">
        <div class="title">企业需求登记 <img src="/static/image/marketCenter/home-certification3.svg" alt="" width="14" height="14"/></div>
        <div class="tips">填写企业相关信息和贷款需求</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bannerContent"
}
</script>

<style scoped lang="less">
.banner-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 2px;
    height: 151px;
    background: rgba(214, 214, 214, 0.5);
    .circle {
      width: 14px;
      height: 14px;
      line-height: 14px;
      background: #D2E4FF;
      border-radius: 50%;
      font-size: 10px;
      font-weight: 500;
      color: #3D8AFF;
      text-align: center;
    }
  }
  .content {
    padding: 10px 12px;
    margin-top: 13px;
    margin-left: 31px;
    width: 208px;
    height: 56px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px dashed #3D8AFF;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #303030;
    }
    .tips {
      font-size: 11px;
      font-weight: 400;
      color: #AEAEAE;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/bannerContent.vue